module.exports = __webpack_public_path__ + "static/about-d6744b656b8f1b61dd6e553655ef0167.jpg";